import { TCustomer, TQuoteParticipant } from 'models';
import { SOLE_TRADER_CUSTOMER_TYPE } from 'config/consts';

export const checkIfCustomerIsNotUnique = (customer: TCustomer, formParticipants?: TQuoteParticipant[]) => {
  const param = (customer.type === 'individual' || customer.props.company_type === SOLE_TRADER_CUSTOMER_TYPE) ? 'pesel' : 'regon';
  return formParticipants?.find(participant => !participant.deleted && participant.customer.props[param] === customer.props[param]);
};
